module.exports = __webpack_public_path__ + "static/media/verified.a53faa34.svg";